module.exports = __webpack_public_path__ + "static/media/art4.354299b8.jpg";